import React, { useContext } from 'react';
import PaymentProvider from 'store/enums/PaymentProvider';
import PaymentMethodFormProps, { PaymentMethodFormHandle } from 'store/types/payments/PaymentMethodFormProps';
import NmiPaymentMethodForm from './Solupay';
import CitiPaymentMethodForm from './Citi';
import { ConfigContext } from 'components/ConfigGuard';

const PaymentMethodForm = React.forwardRef<PaymentMethodFormHandle, PaymentMethodFormProps>((props, ref) => {
  const { paymentConfiguration } = useContext(ConfigContext);
  const paymentProvider = paymentConfiguration?.paymentProvider;

  switch (paymentProvider) {
    case PaymentProvider.Solupay:
      return <NmiPaymentMethodForm ref={ref} {...props} />;
    case PaymentProvider.Citi:
      return <CitiPaymentMethodForm ref={ref} {...props} />;
    default:
      return <NmiPaymentMethodForm ref={ref} {...props} />;
  }
});

PaymentMethodForm.displayName = 'PaymentMethodForm';

export default PaymentMethodForm;
